export const messages = {
  en: {
    group: {
      productNamePlaceholder: 'Enter product name',
      group: {
        title: 'Group Buying Products',
        id: 'ID',
        image: 'Product Image',
        name: 'Product Name',
        people: 'Group People',
        groupPrice: 'Group Price',
        singlePrice: 'Single Price',
        status: 'Status',
        validDate: 'Valid Date',
        hasRebate: 'Has Rebate',
        leaderRebate: 'Leader Rebate',
        operations: 'Operations'
      },
      groupOrder: {
        title: 'Group Orders',
        id: 'Order ID',
        image: 'Product Image',
        name: 'Product Name',
        buyer: 'Buyer',
        leader: 'Group Leader',
        quantity: 'Purchase Quantity',
        people: 'Group People',
        price: 'Group Price',
        status: 'Status',
        rebate: 'Rebate Amount',
        startTime: 'Group Start Time',
        createTime: 'Group Time',
        endTime: 'Deadline'
      }
    }
  },
  zh: {
    group: {
      productNamePlaceholder: '请输入商品名称',
      group: {
        title: '拼团商品',
        id: '编号',
        image: '商品图片',
        name: '商品名称',
        people: '拼团人数',
        groupPrice: '拼团金额',
        singlePrice: '单买金额',
        status: '状态',
        validDate: '有效期',
        hasRebate: '是否返佣',
        leaderRebate: '团长返佣',
        operations: '操作'
      },
      groupOrder: {
        title: '拼团订单',
        id: '订单ID',
        image: '商品图片',
        name: '商品名称',
        buyer: '购买者',
        leader: '团长',
        quantity: '购买数量',
        people: '拼团人数',
        price: '拼团金额',
        status: '状态',
        rebate: '返佣金额',
        startTime: '开团时间',
        createTime: '拼团时间',
        endTime: '截止时间'
      }
    }
  }
}